<template>
  <div>
<!--     <div>
      <h1 class="mb-3">Data Format</h1>
    </div> -->
    <v-card>
      <v-container class="mx-2">
      <!-- <h1>Challenge Evaluation</h1> -->
        <p>
          Full satellite images gathered from DigitalGlobe’s WorldView 3 (WV3) satellites span a total area of over 1,400 square kilometers at 0.3 meter ground sample distance (GSD) resolution. The dataset was prepared in ways that are typical for satellite imagery, including <a href="https://trac.osgeo.org/ossim/wiki/orthorectification" target="_blank">ortho-rectification</a>, <a href="https://en.wikipedia.org/wiki/Pansharpened_image" target="_blank">pan-sharpening</a>, RGB dynamic range adjustment, and atmospheric correction. xView contains more than 1 million labeled instances across 60 object categories. The fields in the geoJSON files include:
        </p>

        <v-container fluid grid-list-lg>
          <v-layout row justify-center>
            <v-flex xs12 sm6>
              <v-data-table
                :headers="headers"
                :items="itemsFields"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.field_name}}</td>
                  <td class="text-xs-left">{{ props.item.description}}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
        <p class="mt-3">
          The GeoTIFF files are broken into two sets: RGB and 8-band. The 8-band set contains 8-band multispectral GeoTIFF images labeled as <em>image_id</em>.tif where <em>image_id</em> is a unique integer. Similarly, the RGB set containes pan-sharpened 3-band RGB GeoTIFF images with the same naming convention.
        </p>

        <p>
          The dataset was segmented into three sets, training, validation, and test, which have roughly 60, 20, and 20 percent of the images respectively. Restrictions were placed on the splits so that each set had enough instances of each category to perform a fair analysis. As with many challenges, all participants will have access to the train and validation images, but during the challenge, labels are provided for only the train dataset. The private test set will be used to evaluate final submissions after the Challenge deadline.
        </p>

        <v-container>
          <v-layout row justify-center>
            <v-flex xs12 sm6>
              <div>
                  <img src="/static/image_challenge_comparison.png" height="333px">
              </div>
            </v-flex>
          </v-layout>
        </v-container>

      </v-container>
    </v-card>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        // foo: 'bar'
        headers: [
          {'text': 'Field Name', 'align': 'left', 'sortable': false, 'value': 'field_name', 'class': 'cardgray'},
          {'text': 'Description', 'align': 'left', 'sortable': false, 'value': 'description', 'class': 'cardgray'}
        ],
        itemsFields: [
          {'value': false, 'align': 'left', 'field_name': 'TYPE_ID', 'description': 'The bounding box label class ID'},
          {'value': false, 'align': 'left', 'field_name': 'CAT_ID', 'description': 'DigitalGlobe\'s unique ID for image strips'},
          {'value': false, 'align': 'left', 'field_name': 'IMAGE_ID', 'description': 'The image chip filename on which a feature is marked'},
          {'value': false, 'align': 'left', 'field_name': 'BOUNDS_IMCOORDS', 'description': 'Bounding box in pixel coordinates [xmin, ymin, xmax, ymax] of the image chip in which it is marked'},
          {'value': false, 'align': 'left', 'field_name': 'COORDINATES', 'description': 'Coordinates in longitude-latitude form for bounding box points'}
        ]
      }
    },
    mounted () {
      // console.log('Challenge Evaluation component mounted')
    }
  }
</script>

<style>
  .data-table {
    max-width: 600px;
    /*padding-left: 12rem;*/
    /*padding-right: 12rem; */
  }
</style>



// WEBPACK FOOTER //
// src/components/Challenge/DataFormat.vue